module.exports = __webpack_public_path__ + "img/US.68f47ea9.jpg";